import {submitToExactag} from '@otto-ec/online-marketing/exactag';
import { AppType, appType } from '../global/appInfo.js';

const SESSION_STARTED_KEY = "advertising_id_session_started"

export const trackAdvertisingId = async () => {
    if (sessionStorage.getItem(SESSION_STARTED_KEY)) {
        return;
    }

    if (appType() === AppType.ANDROID) {
        trackGAID();
    } else if (appType() === AppType.IOS) {
        await trackIDFA();
    }
}

const trackGAID = function () {
    const gaid = window.o_apps_android?.getGoogleAdId?.();
    if (gaid) {
        void submitToExactag({apps: {gaid}});
    }
    sessionStorage.setItem(SESSION_STARTED_KEY, 'true');
}

const trackIDFA = async () => {
    const idfa = await window.webkit?.messageHandlers?.getIDFAToken?.postMessage?.({});
    if (idfa && idfa !== "00000000-0000-0000-0000-000000000000") {
        void submitToExactag({apps: {idfa}});
        sessionStorage.setItem(SESSION_STARTED_KEY, 'true');
    }
}
